<template>
    <div class="el-segmented" ref="controlRef">
        <div class="el-segmented-controls">
            <slot></slot>
        </div>
    </div>
</template>
<script>

function makeElementId(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}

export default {
    props: {
        value: {
            type: [String, Object],
            default() { return {} }
        },
        disabled: {
            type: Boolean,
            default() { return false }
        }
    },
    watch: {
        value() {
            
        },
    },
    data() {
        return {
            activeIndex: 0,
            idGroup: makeElementId(10),
        }
    },
    mounted() {
       
    },
    methods: {
        customHightlight({ left, width}) {            
            this.$refs.controlRef.style.setProperty('--highlight-width', `${width}px`);
            this.$refs.controlRef.style.setProperty('--highlight-x-pos', `${left}px`);
        },
    }
}
</script>